import { render } from "./AppDialog.vue?vue&type=template&id=fba7c46e&scoped=true"
import script from "./AppDialog.vue?vue&type=script&lang=js"
export * from "./AppDialog.vue?vue&type=script&lang=js"

import "./AppDialog.vue?vue&type=style&index=0&id=fba7c46e&lang=scss&scoped=true"

import exportComponent from "/pxplus_official_website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fba7c46e"]])

export default __exports__